import { AxiosAPI } from './AxiosApi';
class CustomerApi extends AxiosAPI {
    createCustomer = async (body, options = {}) => {
        return await this.POST(this.apiSchema.POST.customers.create(), body, options);
    };
    fetchCustomer = async (id, options = {}) => {
        return await this.GET(this.apiSchema.GET.customers.customer(id), options);
    };
    fetchCustomerMatchedGrants = async (id, options = {}) => {
        return await this.GET(this.apiSchema.GET.customers.matchedGrants(id), options);
    };
    fetchCustomerMatchedPF = async (id, options = {}) => {
        return await this.GET(this.apiSchema.GET.customers.matchedPF(id), options);
    };
}
export default new CustomerApi();
